<template>
  <!-- 设备新增/编辑表单 -->
  <a-modal
    :title="formTitle || '新增设备'"
    v-model:visible="open"
    @cancel="onClose"
    :width="1100"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-form-model 
      ref="form" 
      :model="form" 
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <!-- 基本信息 -->
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="设备名称" prop="name">
            <a-input v-model:value="form.name" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="设备码" prop="equipmentCode">
            <a-input v-model:value="form.equipmentCode" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="设备型号" prop="equipmentModel">
            <a-input v-model:value="form.equipmentModel" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="生产厂家" prop="manufactor">
            <a-input v-model:value="form.manufactor" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="厂家电话" prop="phone">
            <a-input v-model:value="form.phone" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="设备类型" prop="type">
            <a-select
              v-model:value="form.type"
              placeholder="请选择"
              allow-clear
              style="width: 100%"
            >
              <a-select-option
                v-for="(d, index) in dict.type['device_type']"
                :key="index"
                :value="d.value"
                >{{ d.label }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="定位器MAC码" prop="wristbandId">
            <a-select
              v-model:value="form.wristbandId"
              show-search
              allow-clear
              :filter-option="filterWristbandOption"
              placeholder="请选择定位器MAC码"
              :loading="wristbandLoading"
            >
              <template v-slot:notFoundContent>
                <a-spin size="small" v-if="wristbandLoading" />
              </template>
              <a-select-option
                v-for="wristband in wristbandOptions"
                :key="wristband.id"
                :value="wristband.id"
              >
                <span class="option-name">{{
                  wristband.mac || wristband.name || '未命名'
                }}</span>
                <span class="option-desc" v-if="wristband.name && wristband.mac"
                  >（{{ wristband.name }}）</span
                >
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="绑定时间" prop="wristbandBindTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.wristbandBindTime"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              :show-time="{ format: 'HH:mm:ss' }"
              placeholder="请选择绑定时间"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="设备描述" prop="description">
            <a-input
              v-model:value="form.description"
              placeholder="请输入"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="设备ID(机器人)" prop="equipmentId">
            <a-input v-model:value="form.equipmentId" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 保养信息 -->
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="保养周期类型" prop="maintenanceCycle">
            <a-select
              v-model:value="form.maintenanceCycle"
              placeholder="请选择"
              allow-clear
              style="width: 100%"
            >
              <a-select-option
                v-for="(d, index) in dict.type['equipment_maintenance_cycle_type']"
                :key="index"
                :value="d.value"
                >{{ d.label }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="保养周期" prop="maintenanceFrequency">
            <a-input-number
              v-model:value="form.maintenanceFrequency"
              :min="0"
              style="width: 100%"
              placeholder="请输入"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 按照图片布局：左列-保养周期，右列-保修截止日期 -->
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="是否需要耗材" prop="isConsumables">
            <a-select
              v-model:value="form.isConsumables"
              placeholder="请选择"
              allow-clear
              style="width: 100%"
            >
              <a-select-option
                v-for="(d, index) in dict.type['equipment_require_consumables']"
                :key="index"
                :value="d.value"
                >{{ d.label }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="保修截止日期" prop="guaranteeTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.guaranteeTime"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择保修截止日期"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="设备状态" prop="equipmentStatus">
            <a-select
              v-model:value="form.equipmentStatus"
              placeholder="请选择"
              allow-clear
              style="width: 100%"
            >
              <a-select-option
                v-for="(d, index) in dict.type['equipment_status']"
                :key="index"
                :value="d.value"
                >{{ d.label }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <!-- <a-col :span="12">
          <a-form-model-item
            v-if="form.isConsumables === '1'"
            label="耗材说明"
            prop="consumablesDescription"
          >
            <a-input
              v-model:value="form.consumablesDescription"
              placeholder="请输入"
              type="textarea"
              allow-clear
            />
          </a-form-model-item>
        </a-col> -->
        <a-col :span="12">
          <a-form-model-item label="设备采购日期" prop="buyTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.buyTime"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择设备采购日期"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="设备采购日期" prop="buyTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.buyTime"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择设备采购日期"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
      </a-row> -->

      <!-- 状态信息 -->
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="状态变更人" prop="statusName">
            <a-input
              v-model:value="form.statusName"
              disabled
              placeholder="自动填入"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <!-- 按照图片布局：右列-状态变更日期 -->
          <a-form-model-item label="状态变更日期" prop="statusDate">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.statusDate"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              placeholder="请选择状态变更日期"
              allow-clear
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="设备参数1" prop="parameterOne">
            <a-input v-model:value="form.parameterOne" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="设备api接口" prop="equipmentApi">
            <a-input v-model:value="form.equipmentApi" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 设备配置信息 -->
   

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="设备参数2" prop="parameterTwo">
            <a-input v-model:value="form.parameterTwo" placeholder="请输入" />
          </a-form-model-item>

        </a-col>
        <a-col :span="12">
          <a-form-model-item label="设备参数3" prop="parameterThree">
            <a-input v-model:value="form.parameterThree" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>

     

      <!-- 操作说明书：倒数第二行 -->
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-model-item label="操作说明书" prop="specification">
            <div class="specification-upload-wrapper">
              <a-input
                :value="getSpecificationFileName()"
                placeholder="请选择文件(PDF/图片)"
                readonly
                class="specification-input"
              />
              <input
                ref="specificationFileInput"
                type="file"
                style="display: none"
                accept=".pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp"
                @change="handleSpecificationFileSelect"
              />
              <a-button
                type="primary"
                class="specification-upload-btn"
                @click="triggerSpecificationFileSelect"
              >
                上传
              </a-button>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <!-- 预览弹窗 -->
      <a-modal
        :visible="specificationPreviewVisible"
        :footer="null"
        :width="900"
        @cancel="handleSpecificationPreviewCancel"
        :title="specificationPreviewTitle"
      >
        <!-- PDF预览 -->
        <div
          v-if="isPdfFile(specificationPreviewUrl)"
          style="text-align: center; margin-bottom: 10px"
        >
          <a-button
            type="link"
            :href="specificationPreviewUrl"
            target="_blank"
            style="margin-right: 10px"
          >
            <a-icon type="download" />下载PDF
          </a-button>
          <a-button type="link" @click="openSpecificationInNewWindow">
            <a-icon type="export" />在新窗口打开
          </a-button>
        </div>
        <iframe
          v-if="isPdfFile(specificationPreviewUrl)"
          :src="specificationPreviewUrl"
          style="width: 100%; height: 600px; border: 1px solid #d9d9d9"
        ></iframe>
        <!-- 图片预览 -->
        <div
          v-else-if="isImageFile(specificationPreviewUrl)"
          style="text-align: center"
        >
          <img
            :src="specificationPreviewUrl"
            alt="预览图片"
            style="max-width: 100%; max-height: 600px"
          />
        </div>
        <div v-else style="text-align: center; padding: 50px">
          <a-icon type="file" style="font-size: 48px; color: #999" />
          <p style="margin-top: 16px; color: #999">无法预览该文件</p>
        </div>
      </a-modal>

      <!-- 设备照片：倒数第一行 -->
      <a-form-model-item label="设备照片" prop="equipmentUrl">
        <file-upload
          :value="form.equipmentUrl"
          type="image"
          :count="9"
          field-name="equipmentUrl"
          @change="handleEquipmentUrlChange"
        />
      </a-form-model-item>

      <!-- 操作按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>

          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 设备新增/编辑表单组件
 * 功能：提供设备的创建和编辑功能
 * - 支持新增设备（需要先选择项目）
 * - 支持编辑设备信息
 * - 使用字典值显示设备类型、保养周期类型、是否需要耗材、设备状态
 * - 表单字段仅包含实际在表单中显示的字段，以及系统必需的 id 和 projectId
 */
import {
  getEquipment,
  addEquipment,
  updateEquipment,
} from '@/api/system/equipment'
import { listWristband } from '@/api/system/wristband'
import UploadFileToOSS from '@/utils/upload-file-to-oss.js'

export default {
  name: 'CreateForm',
  // 字典类型配置
  dicts: [
    'device_type',
    'equipment_maintenance_cycle_type',
    'equipment_require_consumables',
    'equipment_status',
  ],
  data() {
    return {
      // 提交按钮加载状态
      submitLoading: false,
      // 表单标题（添加/修改）
      formTitle: '',
      // 操作说明书文件列表
      specificationFileList: [],
      // 操作说明书预览弹窗显示状态
      specificationPreviewVisible: false,
      // 操作说明书预览URL
      specificationPreviewUrl: '',
      // 操作说明书预览标题
      specificationPreviewTitle: '文件预览',
      // 操作说明书上传加载状态
      specificationUploading: false,
      // 手环选项列表
      wristbandOptions: [],
      // 手环加载状态
      wristbandLoading: false,
      // 表单数据（仅包含表单显示的字段和系统必需字段）
      form: {
        id: null, // 设备ID（编辑时使用）
        projectId: null, // 项目ID（系统自动设置）
        name: null, // 设备名称
        equipmentCode: null, // 设备码
        equipmentModel: null, // 设备型号
        manufactor: null, // 生产厂家
        phone: null, // 厂家电话
        type: null, // 设备类型
        wristbandId: null, // 定位器MAC码
        wristbandBindTime: null, // 绑定时间
        description: null, // 设备描述
        specification: null, // 操作说明书
        maintenanceCycle: null, // 保养周期类型
        maintenanceFrequency: null, // 保养周期
        isConsumables: null, // 是否需要耗材
        consumablesDescription: null, // 耗材说明
        buyTime: null, // 设备采购日期
        guaranteeTime: null, // 保修截止日期
        equipmentStatus: '0', // 设备状态（默认值）
        statusDate: null, // 状态变更日期
        statusName: null, // 状态变更人
        equipmentUrl: null, // 设备照片URL
        equipmentApi: null, // 设备api接口
        equipmentId: null, // 设备ID(机器人)
        parameterOne: null, // 设备参数1
        parameterTwo: null, // 设备参数2
        parameterThree: null, // 设备参数3
      },
      // 表单类型：1-新增，2-修改
      formType: 1,
      // 抽屉显示/隐藏状态
      open: false,
      // 表单验证规则
      rules: {
        // 设备名称：必填
        name: [
          { required: true, message: '设备名称不能为空', trigger: 'blur' },
        ],
        // 设备码：必填
        equipmentCode: [
          { required: true, message: '设备编码不能为空', trigger: 'blur' },
        ],
        // 设备类型：必填
        // type: [
        //   { required: true, message: '设备类型不能为空', trigger: 'change' },
        // ],
        // // 操作说明书：必填
        // specification: [
        //   { required: true, message: '操作说明书不能为空', trigger: 'blur' },
        // ],
      },
    }
  },
  watch: {
    /**
     * 监听操作说明书URL变化
     * 当form.specification变化时，更新文件列表
     */
    'form.specification': {
      deep: true,

      handler(newVal) {
        this.updateSpecificationFileList(newVal)
      },

      immediate: true,
    },
  },
  methods: {
    /**
     * 更新操作说明书文件列表
     * 根据URL更新文件列表显示
     * @param {String} url - 文件URL
     */
    updateSpecificationFileList(url) {
      if (url) {
        this.specificationFileList = [
          {
            uid: '-1',
            name: this.getSpecificationFileName(url),
            status: 'done',
            url: url,
          },
        ]
      } else {
        this.specificationFileList = []
      }
    },

    /**
     * 获取操作说明书文件名
     * 从URL中提取文件名
     * @param {String} url - 文件URL（可选，默认使用form.specification）
     * @returns {String} 文件名
     */
    getSpecificationFileName(url) {
      const fileUrl = url || this.form.specification
      if (!fileUrl) return ''
      const parts = fileUrl.split('/')
      const fileName = parts[parts.length - 1] || ''
      // 如果文件名包含查询参数，去掉查询参数
      return fileName.split('?')[0] || ''
    },

    /**
     * 触发文件选择
     */
    triggerSpecificationFileSelect() {
      this.$refs.specificationFileInput?.click()
    },

    /**
     * 处理文件选择
     */
    handleSpecificationFileSelect(event) {
      const file = event.target.files?.[0]
      if (!file) return

      // 验证文件
      if (!this.beforeSpecificationUpload(file)) {
        // 重置文件输入
        if (this.$refs.specificationFileInput) {
          this.$refs.specificationFileInput.value = ''
        }
        return
      }

      // 上传文件
      this.handleSpecificationUpload({
        file: file,
      })

      // 重置文件输入
      if (this.$refs.specificationFileInput) {
        this.$refs.specificationFileInput.value = ''
      }
    },
    /**
     * 关闭抽屉
     * 触发关闭事件，重置表单
     */
    onClose() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },

    /**
     * 取消按钮操作
     * 关闭抽屉并重置表单
     */
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },

    /**
     * 表单重置
     * 清空表单数据，重置表单类型为新增
     */
    reset() {
      this.formType = 1
      // 重置操作说明书相关数据
      this.specificationFileList = []
      this.specificationPreviewVisible = false
      this.specificationPreviewUrl = ''
      this.specificationPreviewTitle = '文件预览'
      this.specificationUploading = false
      // 清空手环选项
      this.wristbandOptions = []
      this.form = {
        id: null,
        projectId: null,
        name: null,
        equipmentCode: null,
        equipmentModel: null,
        manufactor: null,
        phone: null,
        type: null,
        wristbandId: null,
        wristbandBindTime: null,
        description: null,
        specification: null,
        maintenanceCycle: null,
        maintenanceFrequency: null,
        isConsumables: null,
        consumablesDescription: null,
        buyTime: null,
        guaranteeTime: null,
        equipmentStatus: '0',
        statusDate: null,
        statusName: null,
        equipmentUrl: null,
        equipmentApi: null,
        equipmentId: null,
        parameterOne: null,
        parameterTwo: null,
        parameterThree: null,
      }
    },

    /**
     * 新增按钮操作
     * 检查项目选择，打开新增表单
     * @param {Object} row - 行数据（未使用）
     */
    handleAdd(row) {
      // 检查是否选择了项目
      const currentProjectId = this.$store.getters.currentProjectId
      if (!currentProjectId) {
        this.$message.warning('请先选择项目', 3)
        return
      }
      this.reset()
      this.formType = 1
      // 设置项目ID
      this.form.projectId = currentProjectId
      this.open = true
      this.formTitle = '添加'
      // 新增时加载手环列表（使用vuex的项目ID）
      this.fetchWristbandOptions()
    },

    /**
     * 修改按钮操作
     * 根据ID获取设备详情并打开编辑表单
     * @param {Object} row - 行数据对象
     * @param {Number|String} ids - 设备ID（如果row不存在时使用）
     */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getEquipment({ id: id })
        .then((response) => {
          this.form = response.data
          this.open = true
          this.formTitle = '修改'
          // 编辑时加载手环列表（使用详情的项目ID）
          this.fetchWristbandOptions()
        })
        .catch(() => {
          this.$message.error('获取设备信息失败', 3)
        })
    },

    /**
     * 处理设备照片上传变化
     * 多图上传时，FileUpload组件会返回一个对象，包含equipmentUrl字段（逗号分隔的URL字符串）
     * @param {Object|String} data - 上传返回的数据，可能是对象或字符串
     */
    handleEquipmentUrlChange(data) {
      // 多图上传时，getImg方法会emit一个对象，包含fieldName和fieldNameArr
      // fieldName字段的值是所有图片URL用逗号拼接的字符串
      if (typeof data === 'object' && data !== null) {
        // 如果传入的是对象，提取equipmentUrl字段（逗号分隔的URL字符串）
        if (data.equipmentUrl !== undefined) {
          this.form.equipmentUrl = data.equipmentUrl
        }
      } else if (typeof data === 'string') {
        // 如果传入的是字符串，直接赋值
        this.form.equipmentUrl = data
      }
    },

    /**
     * 操作说明书上传前的验证
     * 检查文件类型和大小
     * @param {File} file - 要上传的文件
     * @returns {Boolean} true-允许上传，false-不允许上传
     */
    beforeSpecificationUpload(file) {
      // 检查文件类型：只允许PDF和图片
      const isPdf =
        file.type === 'application/pdf' ||
        file.name.toLowerCase().endsWith('.pdf')
      const isImage =
        file.type.startsWith('image/') ||
        /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(file.name)

      if (!isPdf && !isImage) {
        this.$message.error('只能上传PDF文件或图片文件！')
        return false
      }

      // 检查文件大小（限制50MB）
      const isLt50M = file.size / 1024 / 1024 < 50
      if (!isLt50M) {
        this.$message.error('文件大小不能超过50MB！')
        return false
      }

      return true
    },

    /**
     * 操作说明书上传处理
     * 使用OSS上传文件
     * @param {Object} info - 上传信息对象
     */
    handleSpecificationUpload(info) {
      this.specificationUploading = true
      new UploadFileToOSS([info.file], {
        finally: (res) => {
          this.specificationUploading = false
          if (res && res.length > 0) {
            const fileUrl = res[0].path || res[0].url
            this.specificationFileList = [
              {
                uid: res[0].uid || Date.now().toString(),
                name: res[0].name || info.file.name,
                status: 'done',
                url: fileUrl,
              },
            ]
            this.form.specification = fileUrl
            this.$message.success('上传成功')
          } else {
            this.$message.error('上传失败')
          }
        },
      })
    },

    /**
     * 操作说明书文件列表变化处理
     * @param {Object} info - 文件列表变化信息
     */
    handleSpecificationChange(info) {
      // 处理文件删除
      if (info.file.status === 'removed') {
        this.specificationFileList = []
        this.form.specification = null
      }
    },

    /**
     * 操作说明书预览处理
     * @param {Object} file - 文件对象
     */
    handleSpecificationPreview(file) {
      const url = file.url || file.response?.url || file.originFileObj?.url
      if (url) {
        this.specificationPreviewUrl = url
        this.specificationPreviewTitle = file.name || '文件预览'
        this.specificationPreviewVisible = true
      } else {
        this.$message.warning('无法预览该文件')
      }
    },

    /**
     * 操作说明书删除确认
     * @param {Object} file - 要删除的文件对象
     * @returns {Promise} 返回Promise，resolve(true)表示确认删除，resolve(false)表示取消删除
     */
    handleSpecificationRemove(file) {
      return new Promise((resolve) => {
        this.$confirm({
          title: '确认删除',
          content: '确定要删除这个文件吗？',
          onOk: () => {
            this.specificationFileList = []
            this.form.specification = null
            resolve(true)
          },
          onCancel: () => {
            resolve(false)
          },
        })
      })
    },

    /**
     * 关闭操作说明书预览弹窗
     */
    handleSpecificationPreviewCancel() {
      this.specificationPreviewVisible = false
      this.specificationPreviewUrl = ''
      this.specificationPreviewTitle = '文件预览'
    },

    /**
     * 在新窗口打开操作说明书
     */
    openSpecificationInNewWindow() {
      if (this.specificationPreviewUrl) {
        window.open(this.specificationPreviewUrl, '_blank')
      }
    },

    /**
     * 判断是否为PDF文件
     * @param {String} url - 文件URL
     * @returns {Boolean} true-是PDF文件，false-不是PDF文件
     */
    isPdfFile(url) {
      if (!url) return false
      return (
        url.toLowerCase().endsWith('.pdf') ||
        url.toLowerCase().includes('.pdf?')
      )
    },

    /**
     * 判断是否为图片文件
     * @param {String} url - 文件URL
     * @returns {Boolean} true-是图片文件，false-不是图片文件
     */
    isImageFile(url) {
      if (!url) return false
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp']
      return imageExtensions.some((ext) => url.toLowerCase().includes(ext))
    },

    /**
     * 获取手环选项列表
     * 新增时：使用vuex的项目ID
     * 编辑时：使用详情的项目ID（form.projectId）
     */
    fetchWristbandOptions() {
      // 优先使用form中的projectId（编辑时从详情获取），如果没有则使用vuex的项目ID（新增时）
      const projectId =
        this.form.projectId || this.$store.getters.currentProjectId
      if (!projectId) {
        this.wristbandOptions = []
        return
      }
      this.wristbandLoading = true
      listWristband({
        projectId: projectId,
        type: 0,
      })
        .then((res) => {
          const list = res && res.data ? res.data : []
          this.wristbandOptions = Array.isArray(list) ? list : []
        })
        .catch(() => {
          this.wristbandOptions = []
        })
        .finally(() => {
          this.wristbandLoading = false
        })
    },
    /**
     * 本地过滤手环选项
     */
    filterWristbandOption(input, option) {
      if (
        !option ||
        !option.componentOptions ||
        !option.componentOptions.children
      ) {
        return false
      }
      const text = option.componentOptions.children
        .map((child) => child.text || (child.elm && child.elm.innerText) || '')
        .join('')
        .toLowerCase()
      return text.includes((input || '').toLowerCase())
    },
    /**
     * 提交表单
     * 验证表单后，根据表单类型调用新增或修改接口
     */
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          // 判断是新增还是修改
          if (this.form.id !== undefined && this.form.id !== null) {
            // 修改设备
            updateEquipment(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .catch(() => {
                this.$message.error('修改失败', 3)
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            // 新增设备
            addEquipment(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                $emit(this, 'ok')
              })
              .catch(() => {
                this.$message.error('新增失败', 3)
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
.bottom-control {
  text-align: right;
  /* margin-top: 24px; */
  /* padding-top: 24px; */
  /* padding-bottom: 24px ; */
  border-top: 1px solid #f0f0f0;
}

.create-form-modal :deep(.ant-modal-body) {
  padding: 20px 16px 30px 16px !important;
}

/* 更强的选择器确保样式生效 */
:deep(.create-form-modal .ant-modal-body) {
  padding: 20px 16px 30px 16px !important;
}

.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.specification-upload-btn {
  border-radius: 4px !important;
}

.two-column-form :deep(.ant-input),
.two-column-form :deep(.ant-input:hover),
.two-column-form :deep(.ant-input:focus),
.create-form-modal :deep(.ant-input),
.create-form-modal :deep(.ant-input:hover),
.create-form-modal :deep(.ant-input:focus) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  background: #FFFFFF !important;
}

/* 带清除按钮的输入框外层样式（解决嵌套问题） */
.two-column-form :deep(.ant-input-affix-wrapper),
.two-column-form :deep(.ant-input-affix-wrapper:hover),
.two-column-form :deep(.ant-input-affix-wrapper-focused),
.create-form-modal :deep(.ant-input-affix-wrapper),
.create-form-modal :deep(.ant-input-affix-wrapper:hover),
.create-form-modal :deep(.ant-input-affix-wrapper-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  background: #FFFFFF !important;
}

/* 带清除按钮的输入框内部input去掉边框，避免嵌套 */
.two-column-form :deep(.ant-input-affix-wrapper .ant-input),
.create-form-modal :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.two-column-form :deep(.ant-select-selector),
.two-column-form :deep(.ant-select-selector:hover),
.two-column-form :deep(.ant-select-focused .ant-select-selector),
.create-form-modal :deep(.ant-select-selector),
.create-form-modal :deep(.ant-select-selector:hover),
.create-form-modal :deep(.ant-select-focused .ant-select-selector) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-picker),
.two-column-form :deep(.ant-picker:hover),
.two-column-form :deep(.ant-picker-focused),
.create-form-modal :deep(.ant-picker),
.create-form-modal :deep(.ant-picker:hover),
.create-form-modal :deep(.ant-picker-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.two-column-form :deep(.ant-input-number),
.two-column-form :deep(.ant-input-number:hover),
.two-column-form :deep(.ant-input-number-focused),
.create-form-modal :deep(.ant-input-number),
.create-form-modal :deep(.ant-input-number:hover),
.create-form-modal :deep(.ant-input-number-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  background: #FFFFFF !important;
  width: 100% !important;
}

.two-column-form :deep(.ant-input-number-input),
.create-form-modal :deep(.ant-input-number-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

.create-form-modal :deep(.ant-form) {
  padding: 0 12px 0px 12px !important;
  margin-bottom: 0 !important;
}

.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}

/* 弹窗按钮样式 */
.create-form-modal :deep(.ant-modal-footer .ant-btn) {
  border-radius: 4px !important;
}

.create-form-modal :deep(.ant-modal-footer .ant-btn-primary) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

.create-form-modal :deep(.ant-modal-footer .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

/* 操作说明书上传样式 */
.specification-upload-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.specification-input {
  flex: 1;
}

.specification-upload-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
  flex-shrink: 0;
}

.specification-upload-btn:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

/* 设备照片上传组件样式 - 仅针对设备照片字段 */
.create-form-modal :deep(.ant-form-item[prop="equipmentUrl"] .ant-upload-select-picture-card),
.create-form-modal :deep(.ant-form-item[prop="equipmentUrl"] .ant-upload-list-picture-card .ant-upload-list-item) {
  width: 100px !important;
  height: 100px !important;
}

.create-form-modal :deep(.ant-form-item[prop="equipmentUrl"] .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img) {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 30px 16px !important;
}

/* 更强的选择器确保样式生效 */
.ant-modal.create-form-modal .ant-modal-body {
  padding: 20px 16px 30px 16px !important;
}

/* 最高优先级选择器 */
body .ant-modal.create-form-modal .ant-modal-body {
  padding-bottom: 30px !important;
}
</style>
